// extracted by mini-css-extract-plugin
export default {"SectionTitleDivs":"SeaLevelRise_SectionTitleDivs__VXSBK","SectionLabels":"SeaLevelRise_SectionLabels__vpjjY","Label":"SeaLevelRise_Label__ZJrb3"};